import { Component, HostListener, OnInit, Renderer2, Inject } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { SlideDetails } from 'src/app/model/slideDetails';
import { DataStoreService } from 'src/app/service/data-store.service';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { UserIdleService } from 'angular-user-idle';
import * as CONSTANTS from '../../constants';
import uniqueRandom from 'unique-random';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Base64 } from 'js-base64';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-base-view',
  templateUrl: './base-view.component.html',
  styleUrls: ['./base-view.component.less'],
  // providers:[TranslateService]
})
export class BaseViewComponent implements OnInit {
  totalSlides;
  innerWidth;
  presentSlideNum = 0;
  slideDetails = SlideDetails;
  currentLang;
  sidebarTitle: string;
  isSidebarVisible: boolean;
  childModal: any;
  timedOut: boolean;
  idle: any;
  isSummaryPage: boolean = false;
  timeoutSubject = new Subject();
  timeout = this.timeoutSubject.asObservable();
  timeoutSeconds = 8;
  didTimerStart = false;
  issessionExpired = false;
  isRequestCallback: boolean;
  flowType: any;
  prequalType = 'P';
  switchType = 'S';
  constructor(private utilService: UtilService, private modalService: NgbModal, private storageService: WebStorageService, private dataStoreService: DataStoreService, private _activatedRoute: ActivatedRoute,
    private _router: Router, private i18nService: I18nService, private translate: TranslateService, private userIdle: UserIdleService,
    private titleService: Title,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document) {
    this._router.events.pipe(
      filter(event => event instanceof NavigationStart),
    ).subscribe((event: NavigationStart) => {
      if (event && event.url && event.url.includes("request-callback")) {
        this.isRequestCallback = true;
      }
    });
    this.utilService.isSummaryPage.subscribe((event) => {
      // alert(event)
      this.isSummaryPage = event;
    })
    if (sessionStorage.getItem("isSessionExpired")) {
      sessionStorage.removeItem("isSessionExpired");
      this._router.navigate(['../home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
  }
  sub;
  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      this.flowType = this.utilService.getFlowType(params);
    })


    if (sessionStorage.getItem("manageSession")) {
      sessionStorage.removeItem("manageSession");
    }
    this.userIdle.startWatching();
    this.issessionExpired = true;
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())))
    const random = uniqueRandom(100000001, 999999999)
    /** code for session timeout */
    this.userIdle.startWatching();
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
    this.checkSessionTime();
    this.userIdle.onTimerStart().subscribe(count => {
      $("#cbcnsent").modal("hide");
      if (count == 1 || this.issessionExpired) {
        $("#cbcnsent").modal("hide");
        this.issessionExpired = false;
        this.didTimerStart = true;
      }
    }
    )
    this.userIdle.onTimeout().subscribe(count => {
      this.userIdle.stopTimer();
      this.issessionExpired = false;
      this.issessionExpired = true;
    })
    this._activatedRoute.paramMap
      .subscribe(params => {
        this.i18nService.setCurrenttLang(params.get('lang'));
        if ((params.get('lang') != null)) {
          if ((params.get('lang').trim() != "en") && (params.get('lang').trim() != "fr")) {
            this._router.navigate(['../en/home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          }
          this.currentLang = this.i18nService.getCurrentLang();
          sessionStorage.setItem("lang_ref", this.i18nService.getCurrentLang());
        }
      });
    this.utilService.sidebarTitle.subscribe(val => {
      this.sidebarTitle = val;
    })
    this.utilService.isSidebarVisible.subscribe(val => {
      this.isSidebarVisible = val;
    })
    /** end of code for session timeout */
    this._activatedRoute.paramMap
      .subscribe(params => {
        this.i18nService.setCurrenttLang(params.get('lang'));
        if ((params.get('lang').trim() != "en") && (params.get('lang').trim() != "fr")) {
          if (!sessionStorage.getItem("currLang")) {
            this._router.navigate(['../en/home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          } else {
            this._router.navigate(['../' + sessionStorage.getItem("currLang") + '/home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          }
        }
        this.currentLang = this.i18nService.getCurrentLang();

        if (this.flowType?.type == this.prequalType) {
          this.translate.get('header.pageTitle').subscribe((res: string) => {
            this.titleService.setTitle(res);
          });
        }
        else if (this.flowType?.type == this.switchType) {
          this.translate.get('header.pageTitleSwitch').subscribe((res: string) => {
            this.titleService.setTitle(res);
          });
        }
        sessionStorage.setItem("lang_ref", this.i18nService.getCurrentLang());
      });
    this.utilService.sidebarTitle.subscribe(val => {
      this.sidebarTitle = val;
    })
    this.utilService.isSidebarVisible.subscribe(val => {
      this.isSidebarVisible = val;
    })
    this.utilService.windowWidth.subscribe(val => {
      this.innerWidth = val;
    });

  }


  clearSession() {
    let currLang = sessionStorage.getItem("currLang");
    sessionStorage.clear();
    sessionStorage.setItem("lang_ref", currLang);
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
    sessionStorage.setItem("currLang", currLang);
    this.userIdle.resetTimer();
    $("#modalSession").modal('hide');
    this.userIdle.startWatching();
    this.issessionExpired = true;
    this._router.navigate(['../' + currLang + '/home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }
  checkSessionTime() {
    let date = new Date(Base64.decode(sessionStorage.getItem("redTm")));
    if (date) {
      if (date.getDate() == new Date().getDate()) {
        let redTime = date.getTime();
        let currTime = new Date().getTime();
        let timeonCibcPortal = currTime - redTime;
        if (Number(timeonCibcPortal) > CONSTANTS.sessionConstants.MAXIDELTIME) {
          this._router.navigate(['../home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' })
            .then(() => {
              window.location.reload();
            });
        }
      }
    }
  }
  resetTimer() {
    this.userIdle.resetTimer();
    this.userIdle.startWatching();
    $("#modalSession").modal('hide');
    this.issessionExpired = true;
  }
  dismissModal() {
    $("#modalSession").modal('hide');
    this.userIdle.stopTimer();
    this.currentLang = sessionStorage.getItem("lang_ref");
    sessionStorage.clear();
    sessionStorage.setItem("lang_ref", this.currentLang);
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
    sessionStorage.setItem("currLang", this.currentLang);
    this.issessionExpired = true;
    if (this.currentLang == "en") {
      window.location.href = environment.api.mortgageHome_en;
    } else {
      window.location.href = environment.api.mortgageHome_fr;
    }
  }
  hideChildModal(): void {
    this.childModal.hide();
  }
  reset() {
    this.idle.watch();
    this.timedOut = false;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.utilService.windowWidth.next(event.target.innerWidth);
  }
}
function DEFAULT_INTERRUPTSOURCES(DEFAULT_INTERRUPTSOURCES: any) {
  throw new Error('Function not implemented.');
}

